import type { TAnomalyLevel } from "./interfaces";

export enum TciChartView {
  gauge = "gauge",
  vertical = "vertical",
}

export const ANOMALY_COLORS: Record<TAnomalyLevel, string> = {
  l1: "rgb(23, 137, 0)",
  l2: "rgb(255, 255, 0)",
  l3: "rgb(255, 0, 0)",
};

export const ANOMALY_L2_BORDER_COLOR = "#9f8600";
export const ANOMALY_TIMELINE_BACKGROUND = "rgba(23, 137, 0, 0.18)";

export const TIMELINE_WIDTH = 1000;
export const TIMELINE_PADDING_X = 36;
export const TIMELINE_BAR_Y = 46;
export const TIMELINE_BAR_MIN_HEIGHT = 58;
export const TIMELINE_TICKS_COUNT = 6;
export const TIMELINE_STRIPE_WIDTH = 8;
export const TIMELINE_STRIPE_GAP = 2;
export const TIMELINE_LANE_GAP = 2;
export const TIMELINE_LANE_MIN_HEIGHT = 12;
export const TIMELINE_AXIS_OFFSET_Y = 14;
export const TIMELINE_LABEL_OFFSET_Y = 26;
export const TIMELINE_BOTTOM_PADDING = 18;
export const TIMELINE_TOOLTIP_OFFSET = 12;
export const TIMELINE_TOOLTIP_MIN_WIDTH = 180;
export const TIMELINE_TOOLTIP_MAX_WIDTH = 320;
export const TIMELINE_TOOLTIP_VIEWPORT_PADDING = 8;
export const TIMELINE_ACTIVE_MARKER_RADIUS = 5;
export const ANOMALY_WARNING_THRESHOLD = 0.35;
export const ANOMALY_CRITICAL_THRESHOLD = 0.7;
export const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const ANOMALY_SOURCE_BIND_TYPES = {
  train: 2,
  point: 3,
  measure: 4,
  mechanism: 16,
  component: 18,
} as const;
